import React from 'react';
import DayItem from './DayItem';

const DayList = (props) => {
    return (
        <div class="col-xs-12 col-md-6">

            {props.days.map((item) => <DayItem  selectDay={props.selectDay}  item={item} key={item.dayName}/>)}

        </div>

    );
};

export default DayList;


// WEBPACK FOOTER //
// ./src/pages/student_schedule/DayList.js